module.exports = __webpack_public_path__ + "img/y- (13).497f81a0.png";